import React from "react";

const Phone = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-phone"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-phone"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm-3.143,18c-.723,0-1.449-.261-2-.813l-.522-.6c-.446-.446-.446-1.17,0-1.616l1.302-1c.446-.446,1.17-.446,1.616,0l1.069,.851c2.071-.791,3.599-2.256,4.5-4.5l-.851-1.069c-.446-.446-.446-1.17,0-1.616l1-1.302c.446-.446,1.17-.446,1.616,0l.6,.522c.552,.551,.813,1.277,.813,2,0,4-5.429,9.143-9.143,9.143Z" />
    </svg>
  );
};

export default Phone;
